import React from 'react';
import classnames from 'classnames';
import TinyEditor from '@gp/components/TinyEditor';
import ReportCard from '../../../components/ReportCard';
import KeyUpdatesContents from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/ProjectUpdateCard/KeyUpdatesContents';
import { handleLinkerTarget } from '@intelligence/utils/commonUtils';

import type { IBaseProps } from '@home/types/common';

interface ICommentProps extends IBaseProps {
  readonly?: boolean;
  // 是否loading
  isLoading?: boolean;
  value: string;
  onChange?: (payload: string) => void;
}

const CARD_TITLE = 'Important GR & Check-in Updates';

const Comment: React.FC<ICommentProps> = (props) => {
  const { style, className, readonly = false, isLoading, value, onChange } = props;

  return (
    <ReportCard
      style={style}
      className={classnames('dbg-dps-report__comment-card', className)}
      title={CARD_TITLE}
      isLoading={isLoading}
    >
      <div className="dbg-wang-editor-box">
        {readonly && <KeyUpdatesContents data={handleLinkerTarget(value)} />}
        {!readonly && (
          <TinyEditor
            className="gp-word-break-word"
            placeholder="Please input Important GR & Check-in Updates"
            status="success"
            value={value}
            getEditorContent={onChange}
          />
        )}
      </div>
    </ReportCard>
  );
};

export default Comment;
